// URLs for ServiceBoss's service history landing pages. Kept apart from the page
// copy so the Functions (sitemaps, routing) do not bundle thousands of words.
//
// ServiceBoss only. A brand gets a page here only if the Complete History Report
// is sold with the Complete History Report: serviceHistory: true in lib/vehicle/makes.js.
// tests/service-history-pages.test.mjs enforces that. A "Honda service history
// check" we do not sell would be untrue, so those makes have no page.
// `reviewed` is the sitemap lastmod: change it when the page's facts are checked.

export const SERVICE_HISTORY_PATH = "/service-history-check";
export const SERVICE_HISTORY_REVIEWED = "2026-10-31";

export const SERVICE_HISTORY_BRANDS = Object.freeze([
  { slug: "bmw", reviewed: "2026-10-31" },
  { slug: "audi", reviewed: "2026-10-31" },
  { slug: "mercedes", reviewed: "2026-10-31" },
  { slug: "volkswagen", reviewed: "2026-10-31" },
  { slug: "ford", reviewed: "2026-10-31" },
  { slug: "vauxhall", reviewed: "2026-10-31" },
  { slug: "toyota", reviewed: "2026-10-31" },
  { slug: "nissan", reviewed: "2026-10-31" },
  { slug: "land-rover", reviewed: "2026-10-31" },
  { slug: "jaguar", reviewed: "2026-10-31" },
  { slug: "mini", reviewed: "2026-10-31" },
  { slug: "skoda", reviewed: "2026-10-31" },
  { slug: "seat", reviewed: "2026-10-31" },
  { slug: "mazda", reviewed: "2026-10-31" },
  { slug: "lexus", reviewed: "2026-10-31" },
  { slug: "porsche", reviewed: "2026-10-31" },
  { slug: "cupra", reviewed: "2026-10-31" },
  { slug: "peugeot", reviewed: "2026-10-31" },
]);

export function hasServiceHistoryPages(brandKey) {
  return brandKey === "serviceboss";
}

export function serviceHistoryBrandPath(slug) {
  return `${SERVICE_HISTORY_PATH}/${slug}`;
}

// The brand slug in a /service-history-check/{slug} path, or null.
export function serviceHistoryBrandSlugFromPath(pathname) {
  const match = String(pathname).match(/^\/service-history-check\/([a-z0-9-]+)\/?$/);
  return match ? match[1] : null;
}
